import * as React from 'react';
import { useSelector } from 'react-redux';

import { DeniedBySanctions } from '../PromotionSection/components/ServiceError/components/DeniedBySanctions';
import { WithoutServicesScreen } from './WithoutServicesScreen';
import { selectIsPromotionForbidden } from '../../../../reducers/v2/promotion/selectors';

export const WithoutServicesScreenContainer = () => {
  const isPromotionForbidden = useSelector(selectIsPromotionForbidden);

  if (isPromotionForbidden) {
    return <DeniedBySanctions />;
  }

  return <WithoutServicesScreen />;
};
